module.exports = __webpack_public_path__ + "img/me-header-background-ms.eca5a2f2.png";